import React from 'react';
import { ShieldCheckIcon, BadgeCheckIcon, HardHatIcon, LeafIcon } from 'lucide-react';
import { images } from '../data/site';
const items = [{
  icon: HardHatIcon,
  title: 'Full Service Builder',
  body: 'Licensed and insured, inside and outside work.'
}, {
  icon: ShieldCheckIcon,
  title: 'State Licensed & Insured',
  body: 'Credentials on file for every project.'
}, {
  icon: BadgeCheckIcon,
  title: 'BBB Member',
  body: 'Member of the Better Business Bureau.'
}, {
  icon: LeafIcon,
  title: 'Lead Safe EPA Certified',
  body: 'Certified for lead-safe work practices.'
}];
export function TrustBand() {
  return <section className="border-y border-steel-200 bg-white" aria-label="Credentials" data-id="element-250" data-mp="2zzm18rmwgl5l">
      <div className="mx-auto grid max-w-7xl gap-6 px-6 py-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-251" data-mp="301qc5tj7ukfd">
        {items.map(item => <div key={item.title} className="flex items-start gap-3" data-id="element-252" data-mp="27j2zn2iacdpw">
            <item.icon className="mt-0.5 h-6 w-6 shrink-0 text-safety" aria-hidden="true" data-id="element-253" data-mp="27h8blfbpw5hl" />
            <div data-id="element-254" data-mp="20xto9onvetbx">
              <p className="font-display text-base font-semibold uppercase tracking-wide text-ink" data-id="element-255" data-mp="210fv1m2xt4t3">
                {item.title}
              </p>
              <p className="text-sm text-steel-500" data-id="element-256" data-mp="1r7rxuq81oytu">{item.body}</p>
            </div>
          </div>)}
      </div>
      <div className="mx-auto flex max-w-7xl items-center gap-6 border-t border-steel-100 px-6 py-4" data-id="element-257" data-mp="1m973v8jdzbdu">
        <img src={images.bbb} alt="Better Business Bureau" className="h-9 w-auto" data-id="element-258" data-mp="1hbym3925h9d4" />
        <img src={images.epa} alt="Lead Safe EPA Certified" className="h-9 w-auto" data-id="element-259" data-mp="1d892ky0c1hyy" />
        <p className="text-xs uppercase tracking-widest text-steel-400" data-id="element-260" data-mp="18b0gwnfz6vsy">
          Serving Southeast Michigan
        </p>
      </div>
    </section>;
}